import api from './api';
import { Manutencao, ApiResponse } from '../types';

export const manutencaoService = {
  listar: async (): Promise<Manutencao[]> => {
    const response = await api.get<Manutencao[]>('/manutencoes');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<Manutencao> => {
    const response = await api.get<Manutencao>(`/manutencoes/${id}`);
    return response.data;
  },

  cadastrar: async (manutencao: Manutencao): Promise<ApiResponse<Manutencao>> => {
    const response = await api.post<ApiResponse<Manutencao>>('/manutencoes', manutencao);
    return response.data;
  },

  atualizar: async (id: number, manutencao: Manutencao): Promise<ApiResponse<Manutencao>> => {
    const response = await api.put<ApiResponse<Manutencao>>(`/manutencoes/${id}`, manutencao);
    return response.data;
  },

  deletar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/manutencoes/${id}`);
    return response.data;
  },

  listarPorVeiculo: async (veiculoId: number): Promise<Manutencao[]> => {
    const response = await api.get<Manutencao[]>(`/manutencoes/veiculo/${veiculoId}`);
    return response.data;
  },
};
